// Sol menü başlıkları; listede olmayan menüler "Genel"e düşer
export const MENU_GROUPS = [
  { key: 'genel', title: 'Genel', fixed: true, paths: ['/', '/work-permits', '/gelen-talepler', '/magazalar', '/companies', '/employees', '/equipment', '/firma-durumu', '/five-star-degerlendirme', '/firma-erisimi'] },
  { key: 'ayarlar', title: 'Ayarlar', paths: ['/locations', '/company-statuses', '/users', '/work-areas', '/job-types', '/templates', '/equipment-types', '/email-settings', '/isg-taahhutname', '/ozel-durumlar', '/talep-zaman-kurallari', '/system-settings'] },
  { key: 'ek', title: 'Ek Özellikler', paths: ['/five-star', '/firma-degerlendirme', '/five-star-basliklar'] },
  { key: 'yardim', title: 'Yardım & Destek & Duyuru', paths: ['/reports', '/dokumantasyon', '/dokumanlar', '/kullanim-kilavuzu', '/firma-kilavuzu', '/duyurularim', '/firma-erisim-gecmisi', '/giris-duyurulari', '/kullanici-duyurulari'] },
];

const groupOf = (path) => (MENU_GROUPS.find(g => g.paths.includes(path)) || MENU_GROUPS[0]).key;

// Sıralı listeyi başlıklara böl (boş başlıklar atlanır)
export const splitGroups = (items) => MENU_GROUPS
  .map(g => ({ ...g, items: items.filter(i => groupOf(i.path) === g.key) }))
  .filter(g => g.items.length > 0);
